import * as React from "react";
import EdButton from "../../generic/edButton";
import { BellSvg } from "../../../assets/icons/svgIcons/bellSvg";
import "../../../assets/scss/components/login/generic/loginCleverTap.scss";

export interface ILoginCleverTapProps {
	// functions to be called on click of respective buttons
	onRegister: () => void;
	onNoThanks: () => void;
	onDontShow: () => void;
}

const LoginCleverTap: React.FC<ILoginCleverTapProps> = props => {
	return (
		<div className="login_clever_wrap">
			<div className="login_clever_cont">
				<h1 className="clev_tit">Register your device with this account</h1>
				<div className="img_sec">
					<BellSvg width="125" height="125" viewbox="0 0 125 125" />
				</div>

				<h3 className="clev_sub_tit">Personalised Notification</h3>
				<p className="clever_txt">Receive only relevant notifications even when not logged in</p>

				<div className="btn_container mg-b15">
					<EdButton className="thanks_btn" value="No Thanks" btnTyp="secondary" slim onClick={props.onNoThanks} />
					<EdButton className="regis_btn" value="Yes, Register" btnTyp="primary" slim onClick={props.onRegister} />
				</div>
				<EdButton className="clev_link" value="Don’t show this message again" btnTyp="secondary" slim onClick={props.onDontShow} />
			</div>
		</div>
	);
};

export default LoginCleverTap;
